import { Injectable } from '@angular/core';
import { environment } from '@envs/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  private clientId = environment.web.client_id;
  private redirectUri = environment.web.redirect_uri;
  private scope = 'openid profile email';

  login(): void {
    const nonce = this.generateRandomString();
    const authUrl =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?client_id=${this.clientId}` +
      `&redirect_uri=${encodeURIComponent(this.redirectUri)}` +
      `&response_type=id_token` +
      `&scope=${encodeURIComponent(this.scope)}` +
      `&nonce=${nonce}` +
      `&prompt=select_account`;

    localStorage.setItem('oauth_nonce', nonce); // необязательно
    window.location.href = authUrl;
  }

  private generateRandomString(length = 16): string {
    return [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
  }
}
